<template lang="pug">
    .card
        .card-body
            h4.card-title.text-center.d-flex.justify-content-between
                i.fa.fa-chevron-left(@click.prevent="prev()")
                span Confirmation
                i.fa.fa-chevron-right(@click.prevent="next()")
            hr
            p.card-text In conformity with the implementing Rules and Regulations of R.A. 10173, known as the "Data Privacy Act of 2012", that seeks to protect all forms of information, be it private, personal or sensitive. I give my consent the use and collection of my personal data by answering the form
            ValidationObserver(ref="Validation" slim)
                ValidationProvider(name="understand", :rules="{required: {allowFalse: false}}" v-slot="{errors}" slim :customMessages="{'required': 'Please read the confirmatory.'}")
                    .custom-control.custom-checkbox
                        input.custom-control-input#understand(type="checkbox" v-model="form.understand")
                        label.custom-control-label(for="understand", :class="{'text-danger': errors.length > 0}")  I understand that my personal information is protected by RA 10173, the Data Privacy Act of 2012, and that I am required to provide truthful and correct information.
                    small.d-block.text-danger(v-if="errors.length > 0") {{ errors[0] }}.
            h6 TERM AND CONSENTS:
            p.card-text As a MEMBER OF Maragusan Growers Multipurpose Cooperative you are hereby obligated to abide the following duties and responsibilities:
        ol
            li Pay the installment of his/her share capital subscription as it falls due and to participate in the capital build-up and savings mobilization activities of the Cooperative;
            li Patronize the Cooperative’s business(es) and services;
            li Participate in the Members' Education Program;
            li Attend and participate in the deliberation of all matters taken during General Assembly Meetings;
            li Observe and obey all lawful orders, decisions, rules and regulations adopted by the Board of Directors and the General Assembly; and
            li Promote the purposes and goals of the Cooperative, the success of its business, the welfare of its members and the cooperative movement in general.
                ValidationObserver(ref="Validation" slim)
                    ValidationProvider(name="agreement", :rules="{required: {allowFalse: false}}" v-slot="{errors}" slim :customMessages="{'required': 'Please read the terms and condition'}")
                        .custom-control.custom-checkbox
                            input.custom-control-input#agreement(type="checkbox" v-model="form.confirm")
                            label.custom-control-label(for="agreement", :class="{'text-danger': errors.length > 0}")  I hereby agree to apply for membership with Maragusan Growers Multipurpose Cooperative, and agree to faithfully obey its rules and regulations as set down in its by laws and amendments thereof, or elsewhere, and the decisions of the general membership meetings as well as those of the board of directors. I will agree to pay the required membership fee. I have undergone PRE-MEMBERSHIP EDUCATION SEMINAR and I also hereby agree to pledge to subscribe of the required share/shares (common stock) value of the cooperative.
                        small.d-block.text-danger(v-if="errors.length > 0") {{ errors[0] }}.
</template>

<style scoped=""></style>

<script>
import { ref, reactive } from '@vue/composition-api';

export default {
  name: 'Confirmatory',

  props: {
    value: {
      type: Object,
      require: true,
    },
  },

  emits: ['prev', 'next'],

  setup(props, { emit }) {
    const Validation = ref(null);
    const form = reactive(props.value);
    const validate = () => {
      emit('input', form);
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };
    return {
      prev,
      next,
      form,
      validate,
      Validation,
    };
  },
};
</script>
